<template>
	<div class="homework-row">
		<label>
			{{ 'Game type' | translate }}
			<select v-model="config.type" class="form-control">
				<option :value="type.value" v-for="(type, index) in gameTypes" :key="index">
					{{ type.label | translate }}
				</option>
			</select>
		</label>
		<!--		<label>-->
		<!--			{{ 'Level' | translate }}-->
		<!--			<select required v-model="config.options.type" class="form-control">-->
		<!--				<option-->
		<!--					:value="digit.value"-->
		<!--					v-for="(digit, index) in additionType"-->
		<!--					:key="index"-->
		<!--				>-->
		<!--					{{ $t(digit.label).toLowerCase() }}-->
		<!--				</option>-->
		<!--			</select>-->
		<!--		</label>-->

		<label>
			{{ 'Digit' | translate }}
			<!-- <select required v-model="config.options.digit" class="form-control">
				<option :value="number" v-for="(number, index) in digits" :key="index">
					{{ number }}
				</option>
			</select> -->

			<div class="level-number text-center">
				<Select v-model="currentDigit" :selected="currentDigit" :optionsColumns="digits" type="homework" />
			</div>
		</label>

		<label>
			{{ 'Complexity' | translate }}
			<select required v-model="config.options.places" class="form-control">
				<option :value="difficult" v-for="(difficult, index) in difficult" :key="index">
					{{ difficult }}
				</option>
			</select>
		</label>

		<!-- <label>
			{{ 'Speed' | translate }}
			<input required type="number" step="0.1" max="10" min="0" :value="config.options.speed" @input="onChangeSpeed"
				@blur="onBlurSpeed" class="form-control" />
		</label>
		<label>
			{{ 'Action with numbers' | translate }}
			<input required type="number" min="3" step="1" max="100" :value="config.options.length" @input="onChangeLength"
				@blur="onBlurLength" class="form-control" />
		</label> -->

		<label>
			{{ 'Speed' | translate }}
			<input required type="number" step="0.1" max="10" min="0.1" v-model="config.options.speed" @blur="onBlurSpeed"
				class="form-control" />
		</label>

		<label>
			{{ 'Action with numbers' | translate }}
			<input required type="number" min="1" step="1" max="100" v-model="config.options.length" @blur="onBlurLength"
				class="form-control" />
		</label>

		<label>
			{{ 'Number of expressions' | translate }}
			<input type="number" :value="config.repeat" @input="onInputRepeat" @blur="onBlurRepeat" min="1" max="10" step="1"
				class="form-control" />
		</label>
	</div>
</template>

<script>
import { DEFAULT_ABACUS_RANDOM_OPTIONS } from '../Create.vue'
import {
	LABELED_ADDITION_TYPES,
	PLACES,
	getAdditionalDigits,
	getAbacusVariants
} from '../../../Games/gameConfig'
import Select from '@/components/UI/Select.vue'
import { get } from 'fingerprintjs2'

export default {
	name: 'abacus-random',
	props: {
		config: Object,
		onInputRepeat: Function,
		onBlurRepeat: Function,
		gameTypes: Array,
	},
	components: {
		Select
	},
	created() {
		// if (this.config.id || this.config.is_created) {
		// 	this.config.id = undefined
		// 	// this.config.is_created = true

		// 	if (this.config.options.type && this.config.options.type != 'abacus_random_2') {
		// 		this.config.options = { ...DEFAULT_ABACUS_RANDOM_OPTIONS }
		// 	}
		// } else {
		// 	// small super-fast fix for make new config object
		// 	this.config.options = { ...DEFAULT_ABACUS_RANDOM_OPTIONS }
		// }

		// this.config.is_created = true

		// if (this.config.id) {
		// 	this.config.id = undefined
		// } else {
		// 	this.config.options = { ...DEFAULT_ABACUS_RANDOM_OPTIONS }
		// }
	},
	methods: {
		onChangeLength({ target }) {
			const {
				value,
				validity: { valid },
			} = target
			this.config.options.length =
				value && !valid ? this.config.options.length : value
			target.value = this.config.options.length
		},
		onBlurLength() {
			if (
				!this.config.options.length ||
				Number(this.config.options.length <= 1)
			) {
				this.config.options.length = 1
			}
		},
		onChangeSpeed({ target }) {
			const {
				value,
				validity: { valid },
			} = target
			this.config.options.speed =
				value && !valid ? this.config.options.speed : value
			target.value = this.config.options.speed
		},
		onBlurSpeed() {
			if (
				!this.config.options.speed ||
				Number(this.config.options.speed <= 0.1)
			) {
				this.config.options.speed = 0.1
			}
		},
	},
	watch: {
		'config.options.places'() {
			// if (this.config.options.places != 1) {
			// 	this.config.options.places = '1'
			// }

			this.config.options.digit = this.digits[0][0]
		},

		'config.options.length'() {
			if (this.config.options.length > 100) {
				this.config.options.length = 100
			}
		},
	},
	computed: {
		currentDigit: {
			get() {
				return this.config.options.digit
			},
			set(value) {
				this.config.options.digit = value
			}
		},
		additionType() {
			return LABELED_ADDITION_TYPES
		},
		difficult() {
			return PLACES
		},
		digits() {
			// const { type, places } = this.config.options
			// return getAdditionalDigits(type, +places)
			// console.log("variants", Number(this.config.places))

			return getAbacusVariants(Number(this.config.options.places))
		},
	},
}
</script>
